import styled from 'styled-components';

import {colors, font} from 'theme';

export const Title = styled.h1`
    margin: 0 0 28px;
    color: ${colors.textPrimary};
    font-family: ${font.family.primary};
    font-size: 20px;
    font-weight: 700;
    line-height: 24px;
    text-transform: uppercase;
`;

export const SectionTitle = styled.h2`
    margin: 28px 0 16px;
    color: ${colors.textPrimary};
    font-family: ${font.family.primary};
    font-size: 16px;
    font-weight: 500;
    line-height: 24px;
    text-transform: uppercase;
`;

export const CodeControls = styled.div`
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    align-items: end;
    gap: 12px;

    @media (max-width: 767px) {
        grid-template-columns: 1fr;
    }
`;

export const CodeCard = styled.div`
    margin-top: 20px;
    padding: 18px 20px;
    border: 1px solid ${colors.border};
    border-radius: 8px;
`;

export const CodeCardHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    padding-bottom: 16px;
    border-bottom: 1px solid ${colors.border};
`;

export const Code = styled.div`
    min-width: 0;
    overflow-wrap: anywhere;
    color: ${colors.textPrimary};
    font-family: 'JetBrains Mono', monospace;
    font-size: 14px;
    font-weight: 600;
`;

export const CodeDetails = styled.div`
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 20px 28px;
    padding-top: 18px;

    @media (max-width: 1023px) {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }

    @media (max-width: 575px) {
        grid-template-columns: 1fr;
    }
`;

export const Detail = styled.div`
    min-width: 0;
`;

export const DetailLabel = styled.div`
    margin-bottom: 5px;
    color: ${colors.textMuted};
    font-size: 12px;
    line-height: 18px;
`;

export const DetailValue = styled.div`
    overflow-wrap: anywhere;
    color: ${colors.textPrimary};
    font-size: 14px;
    line-height: 20px;
`;

export const Actions = styled.div`
    display: flex;
    justify-content: flex-end;
    margin-top: 28px;
`;
